<div class="loader" [appLoaderState]="state$ | async">
    <div class="d-flex align-items-center justify-content-center">
        <img class="loader__image" [class.small]="small" src="assets/image/loaderPage.gif" />
    </div>
</div>
